
import store from '@/store';
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {
  },
  props: {
      id: {
          type: Number,
          required: false
      },
      orderCode: {
          type: String,
          required: false
      }
  }
})
export default class OrderDetails extends Vue {
  id!: number
  orderCode!: string
  get order() {
    if(this.id)
      return store.getters.orders.find((z: { id: number;   }) => z.id == this.id);
    else if(this.orderCode)
      return store.getters.orders.find((z: { orderCode: string;   }) => z.orderCode == this.orderCode);
    else
      return null;
  }
  

}
